import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  ListGuidedWorkflowsResponse,
  GuidedWorkflowDetails,
  CreateGuidedWorkflowRequest,
  CreateGuidedWorkflowResponse,
  UpdateGuidedWorkflowRequest,
  UpdateGuidedWorkflowResponse,
  CreateGWFEnableRule,
  UpdateGWFEnableRule,
} from '@scale/shared/guidedWorkflow/types/api';

const GWF_BASE_PATH = 'corp-api/guided-workflows';

export const getGWF = async (gwfId: string): Promise<GuidedWorkflowDetails | undefined> => {
  try {
    return apiFetch(null, `${GWF_BASE_PATH}/${gwfId}`);
  } catch (err) {
    if (err.status.code === 404) {
      return undefined;
    }
    throw err;
  }
};

export const updateGWF = async (
  gwfId: string,
  gwfDetails: UpdateGuidedWorkflowRequest,
): Promise<UpdateGuidedWorkflowResponse> => {
  return apiFetch(null, `${GWF_BASE_PATH}/${gwfId}`, {
    method: 'PUT',
    body: gwfDetails,
  });
};

export const addGWFEnableRule = async (
  gwfId: string,
  enableRule: CreateGWFEnableRule,
): Promise<void> => {
  return apiFetch(null, `${GWF_BASE_PATH}/${gwfId}/enableRules`, {
    method: 'POST',
    body: enableRule,
  });
};

export const updateGWFEnableRule = async (
  gwfId: string,
  ruleId: string,
  enableRule: UpdateGWFEnableRule,
): Promise<void> => {
  return apiFetch(null, `${GWF_BASE_PATH}/${gwfId}/enableRules/${ruleId}`, {
    method: 'PUT',
    body: enableRule,
  });
};

export const deleteGWFEnableRule = async (gwfId: string, ruleId: string): Promise<void> => {
  return apiFetch(null, `${GWF_BASE_PATH}/${gwfId}/enableRules/${ruleId}`, {
    method: 'DELETE',
  });
};

export const createGWF = async (
  gwfDetails: CreateGuidedWorkflowRequest,
): Promise<CreateGuidedWorkflowResponse> => {
  return apiFetch(null, `${GWF_BASE_PATH}`, {
    method: 'POST',
    body: gwfDetails,
  });
};

export const deleteGWF = async (gwfId: string): Promise<void> => {
  return apiFetch(null, `${GWF_BASE_PATH}/${gwfId}`, {
    method: 'DELETE',
  });
};

type QueryFilters = {
  projectId?: string;
  scenarioId?: string;
  toolType?: string;
  limit?: number;
};

export const listGuidedWorkflows = async ({
  projectId,
  scenarioId,
  toolType,
  limit,
}: QueryFilters): Promise<ListGuidedWorkflowsResponse> => {
  const queryParams: string[] = [];
  if (projectId) {
    queryParams.push(`projectId=${projectId}`);
  }
  if (scenarioId) {
    queryParams.push(`scenarioId=${scenarioId}`);
  }
  if (toolType) {
    queryParams.push(`toolType=${toolType}`);
  }
  if (limit) {
    queryParams.push(`limit=${limit}`);
  }

  const queryStr = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  const res: ListGuidedWorkflowsResponse = await apiFetch(
    null,
    `corp-api/guided-workflows${queryStr}`,
  );
  return res;
};
